module.exports = __webpack_public_path__ + "img/ff1.af03e553.jpg";